// custom-main-collection-product-grid.js

// Initialize Algolia adapter from theme config
if (window.algoliaConfig && window.AlgoliaAdapter) {
  window.AlgoliaAdapter.init(window.algoliaConfig);
}

const wrappers = document.querySelectorAll(".searchspring-wrapper");
const {
  formatPrice,
  generateProductCard,
  renderPagination,
  loadProducts,
  setupSorting,
  setupInfiniteScroll,
  setupFiltering,
} = utils;

wrappers.forEach((wrapper) => {
  const sectionId = wrapper.dataset.sectionId;
  const collectionId = wrapper.dataset.collectionId;
  
  // ── Read products_per_page from theme customization (single source of truth) ──
  // Strictly use the value from section settings - no hardcoded fallback
  const productsPerPageValue = wrapper.dataset.productsPerPage;
  const productsPerPage = parseInt(productsPerPageValue, 10);
  
  // Validate: ensure customization value exists and is valid
  if (!productsPerPageValue || isNaN(productsPerPage) || productsPerPage <= 0) {
    console.error(`[PLP] Invalid or missing products_per_page for section ${sectionId}. Value: "${productsPerPageValue}". Please configure in theme customization.`);
    return;
  }
  
  const paginationType = wrapper.dataset.paginationType;
  const loadMoreAfterCount = parseInt(wrapper.dataset.loadMoreAfterCount, 10);
  const sortSelector = wrapper.querySelector(".sort-by-dropdown");
  const collectionHandle = wrapper.dataset.collectionHandle === "all" ? "" : wrapper.dataset.collectionHandle;
  const searchTerms = wrapper.dataset.searchTerms || "";

  window.utils.currentWrapperData[sectionId] = wrapper.dataset;

  const totalCountElement = wrapper.querySelector(".total_products_count");

  // Filter elements
  const filtersContainer = document.getElementById(
    `filters-container-${sectionId}`
  );
  const activeFiltersContainer = document.getElementById(
    `active-filters-${sectionId}`
  );
  const clearAllBtn = document.getElementById(`clear-all-filters-${sectionId}`);
  const filterToggleBtn = document.getElementById(`filter-toggle-${sectionId}`);
  const collectionControls = wrapper.querySelector(".collection-controls");

  // Elements
  const productGrid = document.getElementById(
    `searchspring-product-grid-${sectionId}`
  );
  const paginationContainer = document.getElementById(
    `searchspring-pagination-${sectionId}`
  );
  const loadingOverlay = wrapper.querySelector(".loading-overlay");
  const infiniteScrollingLoading = document.querySelector(
    ".infinite-scroll-loading"
  );

  // Algolia-compatible base URL: adapter parses this to extract collection, query, etc.
  const siteId = "algolia";
  const searchQuery = searchTerms ? `q=${encodeURIComponent(searchTerms)}&` : "";
  let baseUrl = `https://algolia.proxy/search?${searchQuery}collection_handle=${encodeURIComponent(collectionHandle?.toLowerCase() || "")}`;

  // ── Pull any filter/sort state from the URL so the first API call matches UI ──
  const urlStateActiveFilters = window.utils.getFiltersFromUrl(); // sets window.utils.filterParams & sortParam
  if (!window.utils.sortParam) {
    const defaultSortLabel = sortSelector
      ?.querySelector(".dropdown-selected")
      ?.textContent?.trim();
    window.utils.sortParam = window.utils.sortLabelToParam(defaultSortLabel);
  }
  const initialFilterParams = window.utils.filterParams || "";
  const initialSortParam = window.utils.sortParam || "";
  const initialBaseUrl = `${baseUrl}${initialFilterParams}${initialSortParam ? `&${initialSortParam}` : ""}`;

  // Show/hide loading
  const showLoading = () => {
    const ssrGrid = document.getElementById("ssr-marketing-block-0");
    if (ssrGrid && ssrGrid.style.display !== "none") return;
    loadingOverlay.style.display = "block";
  };
  const hideLoading = () => (loadingOverlay.style.display = "none");

  if (collectionControls) {
    const updateStickyControlState = () => {
      if (!window.matchMedia("(max-width: 768px)").matches) {
        collectionControls.classList.remove("is-stuck");
        return;
      }

      const stickyTop = parseFloat(getComputedStyle(collectionControls).top) || 0;
      const controlsTop = collectionControls.getBoundingClientRect().top;
      collectionControls.classList.toggle("is-stuck", controlsTop <= stickyTop + 1);
    };

    updateStickyControlState();
    window.addEventListener("scroll", updateStickyControlState, { passive: true });
    window.addEventListener("resize", updateStickyControlState);
  }

  // Initial load based on pagination type
  const urlParams = new URLSearchParams(window.location.search);
  // CHANGED: capture initial page from URL so infinite scroll can restore the user's collection scroll state
  const initialPage = parseInt(urlParams.get("page")) || 1;

  // Initialize filtering if filters container exists
  if (filtersContainer) {
    setupFiltering({
      sectionId,
      filtersContainer,
      activeFiltersContainer,
      clearAllBtn,
      filterToggleBtn,
      baseUrl: initialBaseUrl,
      cleanBaseUrl: baseUrl,
      siteId,
      collectionHandle,
      productGrid,
      paginationContainer,
      productsPerPage,
      showLoading,
      hideLoading,
      loadProducts,
      totalCountElement,
      paginationType,
      setupInfiniteScroll,
      loadingOverlay,
      infiniteScrollingLoading,
    });
  }

  // Initialize sorting
  setupSorting({
    sortSelector,
    baseUrl: initialBaseUrl,
    siteId,
    collectionId,
    collectionHandle,
    paginationType,
    productGrid,
    paginationContainer,
    productsPerPage,
    showLoading,
    hideLoading,
    loadProducts,
    loadingOverlay,
    infiniteScrollingLoading,
    setupInfiniteScroll,
    totalCountElement,
    sectionId,
  });

  if (paginationType === "infinite_scroll") {
    setupInfiniteScroll({
      baseUrl: initialBaseUrl,
      productsPerPage,
      productGrid,
      loadingOverlay,
      infiniteScrollingLoading,
      loadProducts,
      totalCountElement,
      sortSelector,
      sectionId,
      loadMoreAfterCount,
      initialPage, // CHANGED: pass initial URL page to infinite scroll setup
    });
  } else {
    loadProducts({
      page: initialPage,
      baseUrl: initialBaseUrl,
      productsPerPage,
      productGrid,
      paginationContainer,
      showLoading,
      hideLoading,
      callback: () => {},
      totalCountElement,
      collectionHandle,
      siteId,
      sectionId,
    });
  }

  const mobileDrawer = document.getElementById(
    `mobile-filter-drawer-${sectionId}`
  );
  const mobileFiltersContainer = document.getElementById(
    `mobile-filters-content-${sectionId}`
  );

  const mobileResetAllBtn = mobileDrawer
    ? mobileDrawer.querySelector(".mobile-reset-all")
    : null;
  const mobileApplyBtn = mobileDrawer
    ? mobileDrawer.querySelector(".bttn")
    : null;
  const mobileCloseBtn = mobileDrawer
    ? mobileDrawer.querySelector(".mobile-filter-close")
    : null;
  const mobileOverlay = mobileDrawer
    ? mobileDrawer.querySelector(".mobile-filter-overlay")
    : null;

  // Handle opening the mobile drawer via the existing filter toggle button
  if (filterToggleBtn && mobileDrawer) {
    filterToggleBtn.addEventListener("click", (e) => {
      // Only activate drawer on small screens
      if (window.innerWidth <= 768) {
        e.preventDefault();
        mobileDrawer.classList.add("active");
        filterToggleBtn.classList.add("active"); // rotate chevron up
      }
    });
  }

  // Helper to close the mobile drawer
  function closeMobileDrawer() {
    mobileDrawer?.classList.remove("active");
    filterToggleBtn?.classList.remove("active"); // rotate chevron down
  }

  // Close interactions
  [mobileCloseBtn, mobileOverlay, mobileApplyBtn].forEach((el) => {
    if (el) {
      el.addEventListener("click", () => {
        closeMobileDrawer();
      });
    }
  });

  // Initialize filtering inside the mobile drawer
  if (mobileFiltersContainer) {
    setupFiltering({
      sectionId,
      filtersContainer: mobileFiltersContainer,
      // Paint into the same active-filters pill row used on the collection
      // page itself (below the "All filters" pill row) rather than the
      // drawer's own internal list, which stays hidden (display:none) and
      // is only visible while the drawer is open.
      activeFiltersContainer: activeFiltersContainer,
      clearAllBtn: mobileResetAllBtn,
      filterToggleBtn: null, // Drawer open/close handled separately
      baseUrl: initialBaseUrl,
      cleanBaseUrl: baseUrl,
      siteId,
      collectionHandle,
      productGrid,
      paginationContainer,
      productsPerPage,
      showLoading,
      hideLoading,
      loadProducts,
      totalCountElement,
      paginationType,
      setupInfiniteScroll,
      loadingOverlay,
      infiniteScrollingLoading,
    });
  }
});

(function initPlpMobileGridToggle() {
  const STORAGE_KEY = "plp-mobile-grid-cols";

  function applyMobileCols(wrapper, cols) {
    if (!wrapper || (cols !== "1" && cols !== "2")) return;

    wrapper.querySelectorAll(".product-grid").forEach((grid) => {
      if (/product-grid--mobile-\d+/.test(grid.className)) {
        grid.className = grid.className.replace(
          /product-grid--mobile-\d+/g,
          `product-grid--mobile-${cols}`
        );
      } else {
        grid.classList.add(`product-grid--mobile-${cols}`);
      }
    });

    wrapper.querySelectorAll(".skeleton-grid").forEach((grid) => {
      if (/skeleton-grid-mobile-\d+/.test(grid.className)) {
        grid.className = grid.className.replace(
          /skeleton-grid-mobile-\d+/g,
          `skeleton-grid-mobile-${cols}`
        );
      } else {
        grid.classList.add(`skeleton-grid-mobile-${cols}`);
      }
    });

    wrapper.querySelectorAll(".grid-toggle [data-mobile-cols]").forEach((btn) => {
      btn.setAttribute(
        "aria-pressed",
        btn.getAttribute("data-mobile-cols") === cols ? "true" : "false"
      );
    });
  }

  document.querySelectorAll(".searchspring-wrapper").forEach((wrapper) => {
    wrapper.addEventListener("click", (event) => {
      const button = event.target.closest("[data-mobile-cols]");
      if (!button || !button.closest(".grid-toggle") || !wrapper.contains(button)) {
        return;
      }

      const cols = button.getAttribute("data-mobile-cols");
      applyMobileCols(wrapper, cols);

      try {
        window.localStorage.setItem(STORAGE_KEY, cols);
      } catch (err) {
        // Ignore private mode / disabled storage
      }
    });
  });
})();
